import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { QestlabListDropdown } from 'Components/List';
import ListType from 'Components/List/QestlabListDropdown/ListType';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { hasValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import { useSelector } from 'react-redux';

let PreparationSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }): JSX.Element => {
  const gaugeId = useSelector(createWorksheetSelector!('NuclearDensityGauge.Id')) as Guid;
  const applyCorrections = useSelector(createWorksheetSelector!('ApplyCorrectionsToMeasurements')) ?? false;
  const gaugeSerialNumber = useSelector(createWorksheetSelector!('NuclearGaugeSerialNumber'));
  const gaugeMakeAndModel = useSelector(createWorksheetSelector!('NuclearGaugeMakeModel'));
  const gaugeModelNumber = useSelector(createWorksheetSelector!('NuclearGaugeModelNumber'));
  const gaugeCalibrationImportMismatch = useSelector(
    createWorksheetSelector!('NuclearDensityGaugeCalibratedImportMismatch')
  );
  const gaugeAdditionalDataImportMismatch = useSelector(
    createWorksheetSelector!('NuclearDensityGaugePropertiesImportMismatch')
  );
  const testNumber = useSelector(createWorksheetSelector!('TestNumber'));

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="TestNumber" visible={hasValue(testNumber)} />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<QestlabListDropdown />} name="Weather" listType={ListType.Weather} maxLength={50} />
        <Field input={<NumericInput />} name="LayerThickness" />
        <Field input={<Checkbox />} name="SandUsedToBedGauge" />
        <FieldSet>
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="nuclear-density-gauge"
            name="NuclearDensityGauge"
            importedCalibration={{
              Mismatch: gaugeCalibrationImportMismatch,
              ModelNumber: gaugeModelNumber,
            }}
            importedAdditionalData={{
              Mismatch: gaugeAdditionalDataImportMismatch,
              SerialNumber: gaugeSerialNumber,
              MakeAndModel: gaugeMakeAndModel,
            }}
            importModel={{ id: gaugeId }}
          />

          <Field input={<TextOutput />} name="NuclearGaugeSerialNumber" />
          <Field input={<TextOutput />} name="NuclearGaugeMakeModel" />
        </FieldSet>
      </ListFieldSection>
      <Field input={<Checkbox />} name="ApplyCorrectionsToMeasurements" />
      <ListFieldSection heading="Bulk Density Correction Factor" visible={applyCorrections}>
        <Field input={<NumericInput />} name="BulkDensityCorrectionSlope" />
        <Field input={<NumericInput />} name="BulkDensityCorrectionIntercept" />
      </ListFieldSection>
    </>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);
export { PreparationSection };
export default PreparationSection;
